'use client';

import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import React, { useEffect, useState } from "react";
import { useLocale } from "next-intl";
import { hotelDetailService } from "@/services/hotelServices/detail";
import { getClientSessionHeaders } from "@/utils/clientSessionHeadersHelper";

const MoreAboutHotel = ({ hotelData = null }) => {
  const t = useTranslationDetector('hotel');
  const locale = useLocale();
  const [otherProducts, setOtherProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const slug = hotelData?.Slug;
  const cityName = hotelData?.City ?? hotelData?.Region ?? '';

  useEffect(() => {
    if (!slug) {
      setOtherProducts([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    const headers = getClientSessionHeaders();

    hotelDetailService
      .getOtherProducts(
        { Slug: slug, LanguageCode: locale || 'tr' },
        headers,
        true
      )
      .then((res) => {
        if (cancelled) return;
        const list = res?.OtherProducts;
        setOtherProducts(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setOtherProducts([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [slug, locale]);

  if (loading || otherProducts.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 md:gap-6 md:pb-12 pb-6 max-md:border-b border-solid border-[#D0D0DC]">
      <div className="text-xl sm:text-[23px] md:text-[29px]! font-semibold">
        {t('moreAbout', { city: cityName || undefined })}
      </div>

      <div className="grid grid-cols-2 gap-4 md:gap-6">
        {otherProducts.map((item, index) => (
          <div className="col-span-2 md:col-span-1" key={item.Slug ? `${item.Slug}-${index}` : index}>
            <a
              href={item.RedirectUrl || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg font-medium"
            >
              {item.Name}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoreAboutHotel;
